module.exports = __webpack_public_path__ + "static/media/false_true_gif.d37c7961.gif";